import { render, staticRenderFns } from "./VisitConsumables.vue?vue&type=template&id=a3de151c"
import script from "./VisitConsumables.vue?vue&type=script&lang=ts"
export * from "./VisitConsumables.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports